import template from './whatIsSolidaryList.html';
import controller from './whatIsSolidaryList.controller';
import './whatIsSolidaryList.scss';

let whatIsSolidaryListComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default whatIsSolidaryListComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryList/whatIsSolidaryList.component.js